import axios from "axios";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";

export const CheckOrder = ({ children }) => {
    const [ isOrderOpen, setIsOrderOpen ] = useState(true);//오더 입력 활성화 여부
    const route = useSelector((state) => state.user.route)

    //오더 입력 활성화 여부 get
    useEffect(() => {
        axios.get('/api/order/is_open')
        .then((data) => {
            if(data.data.orderInput ) setIsOrderOpen(true)
            else setIsOrderOpen(false)
        })
    },[route]) 

    //오더 오픈 안되어있을시 오픈 요청 화면으로 이동
    if (!isOrderOpen) {
        // user is not authenticated
        return <Navigate to="/req-order" />;
    }

    return children;
};